import { buildSlice, CommonState } from '~libs/reduxUtils';

import { ClientClassification } from '~support-at-home/models';

import { getAll, getOne, typePrefix, uploadFile } from '~support-at-home/actions/clientClassifications';

const initialState: CommonState<ClientClassification> = {
  loading: 'idle',
  hasLoaded: false,
  error: null,
  uploadError: null,
  rows: [],
  grouped: [],
};

const slice = buildSlice<CommonState<ClientClassification>, ClientClassification>(typePrefix, initialState, {
  extraReducers(builder) {
    builder.addCase(uploadFile.rejected, (state, action) => {
      state.uploadError = action.payload as string;
    });
  },
  customActions: {
    clear(state) {
      state.rows = [];
    },
    clearError(state) {
      state.uploadError = null;
      state.error = null;
    },
  },
  commonConfig: { getAll, getOne },
});

export const { clear, clearError } = slice.actions;
export default slice.reducer;
